import { Injectable } from '@angular/core';
import { ConfigModel } from '@app/@shared/models/config.model';
import { environment } from '@env/environment';
import { ProductTypeEnum } from '../enums/product-type.enum';
import { I18nService } from '../services';

@Injectable()
export class ConfigService {

  private configurationParam: ConfigModel = environment.defaultsConfig;
  constructor(private i18nService: I18nService) {
    this.i18nService.init();
  }

  public loadConfig(): any {

    const hostName = window.location.hostname;

    return new Promise<void>((resolve) => {

      // versiyon
      this.configurationParam.version = environment.version;

      // domain enermedic.com ise title ve logoyu set ediyoruz.
      if (hostName === 'www.enermedic.com' || hostName === 'enermedic.com') {
        this.configurationParam.projectName = 'Enermedic';
        this.configurationParam.logo = 'enermedic.png';
        this.configurationParam.productType = 99;
        this.i18nService.language = 'en-US';
      }

      // ürün tipi enerthings ise title ve logoyu set ediyoruz.
      else if (environment.productType === ProductTypeEnum.Sentinel) {
        this.configurationParam.projectName = 'Enerthings';
        this.configurationParam.logo = 'enerthings.png';
      }

      resolve();
    });
  }

  /**
   * get configuration
   */
  get configuration(): ConfigModel {
    return this.configurationParam;
  }
}
